<template>
  <div class="redirect-element">
    <div class="redirect-header">
      <span class="redirect-type-badge">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="16 3 21 3 21 8"></polyline>
          <line x1="4" y1="20" x2="21" y2="3"></line>
          <polyline points="21 16 21 21 16 21"></polyline>
          <line x1="15" y1="15" x2="21" y2="21"></line>
          <line x1="4" y1="4" x2="9" y2="9"></line>
        </svg>
        <span>Redirection</span>
      </span>
      <div class="element-actions">
        <button class="action-btn" @click.stop="$emit('duplicate')" title="Dupliquer">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
          </svg>
        </button>
        <button class="action-btn delete-btn" @click.stop="$emit('remove')" title="Supprimer">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6v14a2 2 0 0 1-2-2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
          </svg>
        </button>
      </div>
    </div>
    
    <div class="redirect-content">
      <div class="redirect-form">
        <div class="form-row">
          <div class="redirect-select-container">
            <BlockSelector 
              :value="element.redirection_block" 
              :idBot="idBot" 
              placeholder="Sélectionner un bloc de destination"
              @input="handleBlockInput"
              @change="handleBlockChange" 
              @blocks-loaded="handleBlocksLoaded"
            />
          </div>
        </div>
        
        <div v-if="element.redirection_block" class="selected-info">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
          <span>Redirection configurée vers : 
            <router-link 
              :to="{ 
                name: 'playgroundWithBlock', 
                params: { 
                  idchatbot: idBot, 
                  idblock: element.redirection_block 
                }
              }"
              class="block-link"
            >
              <strong>{{ selectedBlockName || element.redirection_block }}</strong>
            </router-link>
          </span>
        </div>
        
        <div v-else class="no-selection-info">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
          <span>Aucune destination sélectionnée</span>
        </div>
        
        <div class="redirect-description">
          Redirige le flux vers le bloc sélectionné
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlockSelector from '@/components/common/BlockSelector.vue';

export default {
  name: 'RedirectElement',
  components: {
    BlockSelector
  },
  props: {
    element: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    idBot: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedBlockName: '',
      blocksList: []
    }
  },
  watch: {
    'element.redirection_block': {
      immediate: true,
      handler(newVal) {
        if (this.blocksList && this.blocksList.length > 0) {
          const found = this.blocksList.find(b => b.idblock === newVal);
          if (found) {
            this.selectedBlockName = found.blockname || found.idblock;
            return;
          }
        }
        this.selectedBlockName = newVal || '';
      }
    }
  },
  methods: {
    handleBlocksLoaded(blocks) {
      this.blocksList = blocks;
      const targetId = this.element.redirection_block;
      if (targetId) {
        const found = blocks.find(b => b.idblock === targetId);
        if (found) {
          this.selectedBlockName = found.blockname || found.idblock;
        } else {
          this.selectedBlockName = targetId;
        }
      }
    },
    handleBlockInput(val) {
      this.element.redirection_block = val || '';
      this.$emit('update', this.element);
    },
    handleBlockChange(selectedOption) {
      if (selectedOption) {
        this.selectedBlockName = selectedOption.blockname || selectedOption.idblock;
      } else {
        this.selectedBlockName = '';
      }
    }
  }
}
</script>

<style scoped>
.redirect-element {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(20, 48, 40, 0.08);
  border: 1px solid rgba(20, 48, 40, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.redirect-element:hover {
  box-shadow: 0 15px 35px rgba(20, 48, 40, 0.12);
  border-color: rgba(218, 255, 209, 0.5);
  transform: translateY(-2px);
}

.redirect-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  background: #143028; /* Peelo Dark Green */
  border-bottom: 1px solid rgba(218, 255, 209, 0.1);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.redirect-type-badge {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  font-weight: 700;
  color: #daffd1; /* Peelo Mint */
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.redirect-type-badge svg {
  color: #daffd1;
}

.element-actions {
  display: flex;
  gap: 10px;
}

.action-btn {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(218, 255, 209, 0.15);
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(218, 255, 209, 0.7);
  transition: all 0.25s ease;
}

.action-btn:hover {
  background: rgba(218, 255, 209, 0.1);
  color: #daffd1;
  border-color: #daffd1;
  transform: scale(1.05);
}

.delete-btn:hover {
  background: rgba(239, 68, 68, 0.1);
  color: #f87171;
  border-color: #ef4444;
}

.redirect-content {
  padding: 24px;
}

.redirect-form {
  width: 100%;
}

.form-row {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-bottom: 1rem;
}

.redirect-select-container {
  flex: 1;
  position: relative;
}

.selected-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 12px 16px;
  background: rgba(218, 255, 209, 0.25);
  border-radius: 12px;
  border: 1px solid rgba(20, 48, 40, 0.15);
  margin-bottom: 0.75rem;
  font-size: 0.875rem;
  color: #143028;
  font-weight: 500;
  transition: all 0.3s ease;
}

.selected-info svg {
  color: #2c463f;
  flex-shrink: 0;
}

.no-selection-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 12px 16px;
  background: rgba(254, 242, 242, 0.8);
  border-radius: 12px;
  border: 1px solid rgba(239, 68, 68, 0.2);
  margin-bottom: 0.75rem;
  font-size: 0.875rem;
  color: #ef4444;
  font-weight: 500;
  transition: all 0.3s ease;
}

.no-selection-info svg {
  color: #ef4444;
  flex-shrink: 0;
}

.redirect-description {
  font-size: 0.75rem;
  color: #64748b;
  padding-left: 0.5rem;
  font-style: italic;
}

.block-link {
  color: #2c463f;
  text-decoration: none;
  font-weight: 700;
  transition: all 0.2s ease;
  border-bottom: 1px dashed rgba(44, 70, 63, 0.4);
  padding-bottom: 1px;
}

.block-link:hover {
  color: #143028;
  border-bottom-style: solid;
  border-bottom-color: #143028;
}
</style>style>
